import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from "react";
import { Typography, message, Spin, Empty, Row, Col } from "antd";
import {
    FetchCaseDetails, findAllCaseByLead,
    findAllCaseByContact,
    findAllCaseByAccount,
} from "../../../Api/Services/CaseApiServices"
import { useExcryptedNavigation } from '../Filters/FilterConditions';
import { setReDirCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { useProFeatureGuard, PRO_FEATURE_NAMES } from '../../../components/utilities/utilities';

const { Text } = Typography;

const NoteDetails = ({ UrlId, displayData, refreshTrigger, tabKey, page }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { allowed: proAllowed, block: blockPro } = useProFeatureGuard();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const ViewDetailPage = (id, entity) => {
        // Child cases are visible on Standard, but opening a case needs Professional
        if (!proAllowed && /CASE/i.test(String(entity || ""))) {
            blockPro(PRO_FEATURE_NAMES.CASES);
            return;
        }
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const [childCaseData, setChildCaseData] = useState([])
    function findDataByEmail(CaseData) {
        if (CaseData?.requesterType === "Leads" || CaseData?.requesterType === "Contacts") {
            return {
                type: CaseData?.requesterType === "Leads" ? 'LEAD' : "CONTACT",
                name: CaseData?.caseCreater,
                email: CaseData?.caseCreaterEmail,
                cPermission: CaseData?.requesterPermission,
                id: CaseData?.caseCreaterId,
                profilePic: CaseData?.createrProfile,
            }
        }
        return {
            type: 'OTHER',
            name: CaseData?.caseCreater,
            email: CaseData?.caseCreaterEmail,
            cPermission: false,
            id: null,
            profilePic: null,
        };
    }
    async function getCaseData1(params) {
        try {
            const competitionArray = params.split(',').map(item => Number(item.trim()));
            const results = await Promise.all(
                competitionArray.map(async (competitionId) => {
                    const Response = await FetchCaseDetails(competitionId)
                    const RequesterResponse = findDataByEmail(Response?.data)
                    const DataSet = {
                        ...Response?.data,
                        AssigneeName: `${Response.data?.caseOwnerFirstName} ${Response.data?.caseOwnerLastName}`,
                        AssigneeEmail: Response.data?.caseOwnerEmail,
                        AssigneeProfile: Response.data?.caseOwnerProfilePic,
                        AssigneeID: Response.data?.caseOwner,
                        RequesterData: RequesterResponse,
                        casePresent: Response?.allow ? "Yes" : "No",
                        caseLinkType: Response?.CaseLinkType
                    }
                    return DataSet;
                })
            );
            const SortedData = results.sort((a, b) => b.caseId - a.caseId);
            setChildCaseData(SortedData);
        } catch (error) {
            message.error(error);
        }
    }
    async function getCaseList(params) {
        try {
            let AllCase;
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                AllCase = await findAllCaseByLead(params)
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                AllCase = await findAllCaseByContact(params)
            }
            else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                AllCase = await findAllCaseByAccount(params)
            }
            const results = await Promise.all(
                AllCase?.map(async (item) => {
                    const RequesterResponse = findDataByEmail(item)
                    const DataSet = {
                        ...item,
                        AssigneeName: `${item?.caseOwnerFirstName} ${item?.caseOwnerLastName}`,
                        AssigneeEmail: item?.caseOwnerEmail,
                        AssigneeProfile: item?.caseOwnerProfilePic,
                        AssigneeID: item?.caseOwner,
                        RequesterData: RequesterResponse,
                        casePresent: item?.allow ? "Yes" : "No",
                        caseLinkType: item?.CaseLinkType
                    }
                    return DataSet;
                })
            );

            const SortedData = results.sort((a, b) => b.caseId - a.caseId);
            setChildCaseData(SortedData);
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (page === "Child") {
            if (displayData?.childCase) {
                if (refreshTrigger === tabKey) {
                    getCaseData1(displayData?.childCase)
                }
            }
            else {
                setChildCaseData([])
            }
        } else if (page !== "Child") {
            if (UrlId !== undefined && UrlId !== null && (UrlId[0] === "?LEAD" || UrlId[0] === "?CONTACT" || UrlId[0] === "?ACCOUNT")) {
                if (refreshTrigger === tabKey) {
                    getCaseList(UrlId[1])
                } else {
                    setChildCaseData([])
                }
            }
        }
    }, [displayData, refreshTrigger, tabKey])
    return (
        <>
            <Row gutter={30}>
                {childCaseData ? (childCaseData?.length > 0 ?
                    childCaseData?.map((item, index) => {
                        return (
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                <div className='RightSide-DataShadow' key={index} style={{ marginBottom: 15 }}>
                                    <div className={`user-info_image ${item?.casePresent === "Yes" && "ListNavigate"}`}
                                        role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                        tabIndex={0}
                                        onClick={item?.casePresent === "Yes" ? () => ViewDetailPage(item?.caseId, item?.caseLinkType) : undefined}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                ViewDetailPage(item?.caseId, item?.caseLinkType);
                                            }
                                        }}
                                    >
                                        <span className='list_span_Tag' style={{ flexShrink: 0, }}>
                                            {item?.caseSubject?.slice(0, 1).toUpperCase()}
                                        </span>
                                        <figcaption style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden", // 👈 keeps ellipsis responsive
                                        }}>
                                            <div style={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }} title={item?.caseSubject}> {item?.caseSubject}</div>
                                            <div style={{
                                                fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }} title={item?.caseNumber}>{item?.caseNumber}</div>
                                        </figcaption>
                                    </div>
                                    <Row gutter={30}>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.caseType && item?.caseType !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Type</Text> <br />
                                                    <Text >{item?.caseType}</Text>
                                                </div> : <></>}  </Col>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.caseStatus && item?.caseStatus !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Status</Text> <br />
                                                    <Text ><div className={`status-text CaseStatus-${item?.caseStatus === "On Hold" ? "OnHold" : item?.caseStatus}`}>{item?.caseStatus}</div></Text>
                                                </div> : <></>}</Col>
                                    </Row>
                                    <Row gutter={30}>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.caseOrigin && item?.caseOrigin !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Origin</Text> <br />
                                                    <Text >{item?.caseOrigin}</Text>
                                                </div> : <></>
                                            }</Col>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {(item?.casePriority && item?.casePriority !== "") ?
                                                <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Priority</Text> <br />
                                                    <Text >{item?.casePriority}</Text>
                                                </div> : <></>
                                            }
                                        </Col>
                                    </Row>
                                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Requester</Text> <br />
                                        <Text> <div className={`user-info_image ${item?.RequesterData?.cPermission && "ListNavigate"}`}
                                            style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }} tabIndex={0} role="button"
                                            onClick={item?.RequesterData?.type !== "OTHER" ? () => item?.RequesterData?.cPermission && ViewDetailPage(item?.RequesterData?.id, item?.RequesterData?.type) : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(item?.RequesterData?.id, item?.RequesterData?.type)
                                                }
                                            }}>
                                            {item?.RequesterData?.profilePic !== null && item?.RequesterData?.profilePic
                                                !== undefined && item?.RequesterData?.profilePic !== "" ?
                                                <figure>
                                                    <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.RequesterData?.profilePic} alt="" />
                                                </figure>
                                                :
                                                <span className={`list_span_Tag ${item?.RequesterData?.type === "LEAD" ? "LeadIcon" :
                                                    item?.RequesterData?.type === "CONTACT" ? "ContactIcon" : ""}`} style={{ flexShrink: 0, }}>
                                                    {item?.RequesterData?.name?.slice(0, 1).toUpperCase()}
                                                </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={item?.RequesterData?.name}>{item?.RequesterData?.name}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={item?.RequesterData?.email}>{item?.RequesterData?.email}</div>
                                            </figcaption>
                                        </div></Text>
                                    </div>
                                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Assignee</Text> <br />
                                        <Text ><div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.AssigneeID) && "ListNavigate"}`}
                                            role="button" style={{ padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0, }}
                                            tabIndex={0}
                                            onClick={(Role === "Administrator" || profile.userId === item?.AssigneeID) ? () => item?.AssigneeID && ViewDetailPage(item?.AssigneeID, "USER") : undefined}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    ViewDetailPage(item?.AssigneeID, "USER");
                                                }
                                            }}
                                        >  {item?.AssigneeProfile !== null && item?.AssigneeProfile
                                            !== undefined && item?.AssigneeProfile !== "" ?
                                            <figure>
                                                <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.AssigneeProfile} alt="" />
                                            </figure>
                                            :
                                            <span className='list_span_Tag UserIcon' style={{ flexShrink: 0, }}>
                                                {item?.AssigneeName?.slice(0, 1).toUpperCase()}
                                            </span>
                                            }
                                            <figcaption style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                overflow: "hidden", // 👈 keeps ellipsis responsive
                                            }}>
                                                <div style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={item?.AssigneeName}>{item?.AssigneeName}</div>
                                                <div style={{
                                                    fontSize: 12, color: "#adb4d2", overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }} title={item?.AssigneeEmail}>{item?.AssigneeEmail}</div>
                                            </figcaption>
                                        </div></Text>
                                    </div>
                                </div>
                            </Col>
                        )
                    }) :
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div></Col>)
                    :
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <div className="spin">
                            <Spin />
                        </div></Col>
                }
            </Row>
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
};
export default React.memo(NoteDetails)